export default "__VITE_ASSET__BdvaRxYP__"